import React, { FC } from 'react';
import classNames from 'classnames';
import { DealRoom } from 'models/DealRoom';
import useQueryParams from 'hooks/useQueryParams';
import { getHasElementsInArray } from 'utils';
import RecentSearches from '../RecentSearches';
import RecentlyViewedDeals from '../RecentlyViewedDeals';
import RecentActivityPanelSkeleton from './components/RecentActivityPanelSkeleton';

import './RecentActivityPanel.styles.scss';

type RecentActivityPanelProps = {
  className?: string;
  isLoading?: boolean;
  recentSearches: string[];
  recentlyViewedDeals: DealRoom[];
};

const RecentActivityPanel: FC<RecentActivityPanelProps> = (props) => {
  const { className, isLoading, recentSearches, recentlyViewedDeals } = props;

  const { removeAllQueryParams, setQueryParam } = useQueryParams();

  const hasRecentSearches = getHasElementsInArray(recentSearches);
  const hasRecentlyViewedDeals = getHasElementsInArray(recentlyViewedDeals);

  const classes = classNames('recent-activity-panel', 'white-panel', className);

  if (isLoading)
    return (
      <div className={classes}>
        <RecentActivityPanelSkeleton />
      </div>
    );

  if (!hasRecentSearches && !hasRecentlyViewedDeals) return null;

  return (
    <div className={classes}>
      <RecentSearches
        searches={recentSearches}
        onSelect={(term) => {
          removeAllQueryParams();
          setQueryParam('searchString', term);
        }}
      />

      {hasRecentSearches && hasRecentlyViewedDeals && (
        <div className="border" />
      )}

      <RecentlyViewedDeals deals={recentlyViewedDeals} />
    </div>
  );
};

export default RecentActivityPanel;
